import {
  UpdateIconButton,
  formatBoolean,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import { ListBeProperty } from "components";
import { GradeListDto, GradeListResource, Permission, PermissionAction, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { gradePageRoute } from "../GradePage/GradePage";

export const GradeTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  grades: GradeListDto[];
  setGrades: (grades: GradeListDto[]) => void;
  resource: GradeListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<GradeListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<GradeListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<GradeListDto>("passing"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<GradeListDto>("atRisk"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.grades.map((gradeItem) => (
            <TableRow
              key={gradeItem.id}
              onClick={() =>
                navigate(
                  gradePageRoute.getPath({
                    id: gradeItem.id,
                    crudMode: "view",
                  })
                )
              }
            >
              <TableCell type="id">{gradeItem.id}</TableCell>
              <TableCell>{gradeItem.name}</TableCell>
              <TableCell>{formatBoolean(gradeItem.passing)}</TableCell>
              <TableCell>{formatBoolean(gradeItem.atRisk)}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() =>
                      navigate(
                        gradePageRoute.getPath({
                          id: gradeItem.id,
                          crudMode: "edit",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
